import React from "react";

const SubMenu = ({ subMenuList, position, toggleMenuVisibility }) => {

    const handleSubMenuItemClick = (item) => {
        navigatePage(item.data.onTap)
        toggleMenuVisibility();
    };

    const navigatePage = (data) => {
        if (data.NavigationType === "3") {
            const currentQueryParams = window.location.search;
            var newQueryParams = removeQueryParam(currentQueryParams, 'type');
            newQueryParams = removeQueryParam(newQueryParams, 'typeId');
            newQueryParams = removeQueryParam(newQueryParams, 'pageId');
            console.log(JSON.stringify(data));
            if (data.FSN === "103") {
                localStorage.setItem("productId", data.FAI.productId);
                localStorage.setItem("FSN", data.FSN);
                window.location.href = `/product_detail_page${newQueryParams}`;
              } else if (data.FSN === "125") {
                localStorage.setItem("type", data.FAI.type);
                localStorage.setItem("typeId", data.FAI.typeId);
                localStorage.setItem("FSN", data.FSN);
                window.location.href = `/store_category_grid_page${newQueryParams}`;
              }
        }
    };

    const removeQueryParam = (url, param) => {
        const urlObj = new URL(url, window.location.origin); // Create a URL object
        urlObj.searchParams.delete(param); // Remove the parameter
        return urlObj.search; // Return the new query string
    };

    return (
        <ul
            style={{
                listStyleType: "none",
                margin: 0,
                padding: "0.5rem",
                backgroundColor: "#f1f1f1",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                position: "absolute",
                top: position?.top || 0,
                left: position?.left || 0,
                zIndex: 1001,
                maxHeight: "500px", // Limit height for submenu
                overflowY: "auto", // Allow vertical scrolling if needed
            }}
        >
            {subMenuList[0].cardData?.map((item, index) => (
                <li
                    onClick={(e) => handleSubMenuItemClick(item)}
                    key={index}
                    style={{
                        width: '150px',
                        fontSize: '10px',
                        padding: "0.75rem",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: "500",
                        textAlign: "left",
                        margin: "0.25rem 0",

                    }}
                >
                    {item.data.itemName}
                </li>
            ))}
        </ul>
    );
};

export default SubMenu;
